import {observer} from 'mobx-react-lite'
import * as React from 'react'
import {Lang} from 'yougile-lang'
import {Util} from 'yougile-util'
import {getNextScheduledReadable, Hub, scheduleToReadable} from 'yougile-model'
import {Sync} from '@client/sync'
import {showConfirm} from '@components/common/base/notifications'
import {noPropagate} from '../../containers/hooks'
import {MessageBox} from '../message-box'
import {repeatStore} from './repeat-store'

export const RepeatEditTemplateRow = observer(
  (props: {hub: Hub; isStopped: boolean}) => {
    const bem = Util.bemFrom('repeat-edit')
    const {hub, isStopped} = props

    const rt = hub.data.repeatTemplate
    if (!rt) {
      return null
    }

    const colName = Sync.getCurrentSandbox().getHub(rt.columnId)?.title

    const edit = () => {
      if (!repeatStore.canEdit) {
        MessageBox.warn(Lang.msg.repeat.canEditWarn)
        return
      }
      repeatStore.create(hub, true)
    }

    const remove = async () => {
      if (!repeatStore.canEdit) {
        MessageBox.warn(Lang.msg.repeat.canEditWarn)
        return
      }
      if (await showConfirm(Lang.msg.repeat.deleteWarn)) {
        hub.deleted = true
        hub.commit()
      }
    }

    return (
      <div
        key={hub.id}
        className={bem('row', {
          highlighted: repeatStore.state.highlighted === hub.id
        })}
        onClick={edit}
      >
        <div className={bem('col')}>
          <div className={bem('col-name', {isStopped})}>{rt.title || '—'}</div>
        </div>
        <div className={bem('col')}>{colName}</div>
        <div className={bem('col', {inactive: isStopped})}>
          {isStopped
            ? Lang.msg.repeat.stopped
            : scheduleToReadable(rt.schedule)}
        </div>
        <div className={bem('col', {inactive: isStopped})}>
          {isStopped
            ? ''
            : rt.schedule && getNextScheduledReadable(rt.schedule)}
        </div>
        <div className={bem('col')} onClick={noPropagate}>
          <div
            className={bem('action', {
              start: isStopped,
              stop: !isStopped
            })}
            onClick={() => repeatStore.toggleTemplateState(hub)}
          >
            {isStopped
              ? Lang.msg.repeat.actionStart
              : Lang.msg.repeat.actionStop}
          </div>
          <div className={bem('action', {del: true})} onClick={remove}>
            {Lang.msg.repeat.actionDelete}
          </div>
        </div>
      </div>
    )
  }
)
